export const MARQUEE_SHOW = '/api/mktop/activitiesShowService/marqueeShow';
export const RANK_SHOW = '/api/mktop/activitiesShowService/activitiesRankingShow';
export const SWEEPS_CREDIT = '/api/mktop/winningService/increaseCredit';
export const SWEEPS_CREDITV2 = '/api/mktop/winningService/increaseCreditV2';
export const RESIDUE_DEGREE = '/api/mktop/winningService/residueDegree';
export const RECORD_QUERY = '/api/mktop/winningService/winningRecordQuery';
